module.exports = __webpack_public_path__ + "img/ec3.36ff69e3.jpg";